const Icon: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_364_33037)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 6.83331C10.9374 6.83331 6.83337 10.9374 6.83337 16C6.83337 21.0626 10.9374 25.1666 16 25.1666C21.0626 25.1666 25.1667 21.0626 25.1667 16C25.1667 10.9374 21.0626 6.83331 16 6.83331ZM16.8334 11.8333C16.8334 11.3731 16.4603 11 16 11C15.5398 11 15.1667 11.3731 15.1667 11.8333V16C15.1667 16.4602 15.5398 16.8333 16 16.8333C16.4603 16.8333 16.8334 16.4602 16.8334 16V11.8333ZM13.333 14.0001C13.6094 13.6322 13.5352 13.1098 13.1673 12.8333C12.7993 12.5569 12.2769 12.6311 12.0005 12.999C11.3725 13.8348 11 14.8751 11 16C11 18.7614 13.2386 21 16 21C18.7615 21 21 18.7614 21 16C21 14.8751 20.6276 13.8348 19.9996 12.999C19.7232 12.6311 19.2008 12.5569 18.8328 12.8333C18.4649 13.1098 18.3907 13.6322 18.6671 14.0001C19.0857 14.5572 19.3334 15.2485 19.3334 16C19.3334 17.8409 17.841 19.3333 16 19.3333C14.1591 19.3333 12.6667 17.8409 12.6667 16C12.6667 15.2485 12.9144 14.5572 13.333 14.0001Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_364_33037"
          x="-2"
          y="-1"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_364_33037"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_364_33037"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Icon
